import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './DueDate.css';
import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
import FaqsDisclaimer from '../common/FaqsDisclaimer';
import Service from '../../service/Service';
import DisclaimerReferences from "../common/DisclaimerReferences";
import { withRouter } from 'react-router-dom';
import relatedArticles from './relatedArticles'
import withLocation from "../../../withLocation";
const service = new Service();

class DueDate extends Component {
    constructor(props) {
        super(props);
        console.log("#############DueDateLanding component loaded*************",props);
        this.dateRef = React.createRef();
        let initialData = [];
        let calculateDueDateData = [];
        
       
        if (__isBrowser__ && window.__initialData__) {
            initialData = window.__initialData__['initialData'];
            calculateDueDateData = initialData['result'] ? initialData['result'] : [];
            console.log("initialData in DueDateLanding component", calculateDueDateData);


            delete window.__initialData__;

        } else {
            if (props.staticContext) {
                initialData = props.staticContext.initialData['initialData'];
                calculateDueDateData = initialData['result'] ? initialData['result'] : [];
            }
        }

        this.state = {
            
          minDuedate: '',
          maxDuedate: '',
          minChilddate: '',
          maxChilddate: '',
          aDays: '',
          conceptionDate: '',
          firstDate: '',
          loggedin: false,
          IsExpected: false,
          selectedMethod: 'Last Period',
          initialData: initialData,
          shortMonth: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          objects: [21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35],
          selectedCycleLength: '28 Days',
          selectedPregnancyLength: '28 Weeks',
          selectedPregnancyLengthDay: '5 Days',
          selectedTransferMethod: '5 Day transfer',
          isMethodOpen: false,
          isCycleLengthOpen: false,
          isPregnancyLengthOpen: false,
          isPregnancyLengthDayOpen: false,
          isTransferMethodOpen: false,
          isDescExpanded: false,
          activeDropdownType: '',
          calculateDueDateData : calculateDueDateData,
          noLMPDate : false,
          errMsgLMP : '',
          noIVFDate : false,
          errMsgIVF : '',
          noConceptionDate : false,
          errMsgConception : '',
          noUltrasoundDate : false,
          errMsgUltrasound : '',
          dateISO: props.defaultISO || "" 
      }
        
    }
    static initialAction(reqUrl, ftk, authData, uId) {

        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "duedate/getduedateuserdetails";
        let body = JSON.stringify({})
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {

        const isCallAgain = window.location.search.includes("callAgain=y");

        if (global.ftk) {
          if (this.state.calculateDueDateData && !isCallAgain) {
            console.log("calculateDueDateData==================>1", this.state.calculateDueDateData);
        
            const data = this.state.calculateDueDateData;
        
            // ✅ Skip redirect if all fields are empty or default
            const isOnlyDefaultData =
              data.dueFlag === 0 &&
              !data.conceptionDate &&
              !data.lmpDate &&
              !data.avgcycledays &&
              !data.ultrasoundDate &&
              !data.ultrasoundWeek &&
              !data.ultrasoundDays &&
              !data.ivfTransferDate &&
              !data.embryoTransfer;
        
            if (isOnlyDefaultData) {
              console.log("Redirection skipped: due to default or empty calculateDueDateData");
              return;
            }
        
            const redirectUrl = this.generateDueDateUrl(data);
            window.location.href = service.getRedirectUrl(redirectUrl);
          }
        }
        
        else {
          // Non-logged-in user: check localStorage
          const savedDueDateData = localStorage.getItem("dueDateData");
          if (savedDueDateData && !isCallAgain) {
            try {
              const parsedData = JSON.parse(savedDueDateData);
              console.log("Non-logged-in: Redirecting using localStorage data", parsedData);
              const redirectUrl = this.generateDueDateUrl(parsedData);
              window.location.href = service.getRedirectUrl(redirectUrl);
            } catch (e) {
              console.error("Error parsing dueDateData from localStorage", e);
              localStorage.removeItem("dueDateData");
            }
          }
        }
        // if (!(this.props.location.search == "?callAgain=y") && (this.state.initialData) && (this.state.initialData['msg'] == 1 && this.state.initialData['result'].dueFlag)) {
        //     let JsonData = this.state.initialData['result'];
        //     if (JsonData.lmpDate) {
        //         console.log("componentDidMount==================>2",this.state.initialData);
        //         let fDate = new Date(JsonData.lmpDate.replace(/-/g, '/'));
        //         this.state.firstDate = fDate.getDate() + "-" + this.state.shortMonth[fDate.getMonth()] + "-" + fDate.getFullYear();
        //     } else {
        //         this.state.firstDate = 0
        //     }
        //     if (JsonData.avgcycledays) {
        //         this.state.aDays = JsonData.avgcycledays
        //     } else {
        //         this.state.aDays = 0
        //     }
        //     if (JsonData.conceptionDate) {
        //         let cDate = new Date(JsonData.conceptionDate.replace(/-/g, '/'));
        //         this.state.conceptionDate = cDate.getDate() + "-" + this.state.shortMonth[cDate.getMonth()] + "-" + cDate.getFullYear();
        //     } else {
        //         this.state.conceptionDate = 0
        //     }
        //     // let redirectionUrl = "/tools/pregnancy-due-date-calculator/details/" + this.state.firstDate + "/" + this.state.aDays + "/" + this.state.conceptionDate;
        //     // this.props.history.push(redirectionUrl);
        // }
        // if (global.userAry['IsExpected'] || global.ftk != '') {
        //     this.setState({ IsExpected: true, loggedin: true });
        //     console.log("componentDidMount ====> true ");
        // } else {
        //     this.setState({ IsExpected: false, loggedin: false });
        // }
        // this.landDueDatePage();

            service.loadImages();
            document.addEventListener('click', this.handleOutsideClick);
 
            // setTimeout(function() {              
            //    document.querySelectorAll('.content_box_wrap').forEach((box) => {
            //     const ans = box.querySelector('.content_ans_wrap');
            //     const readMoreBtn = box.querySelector('.desc_readmore');
            //     ans.classList.remove('line_hide');
            //     const fullHeight = ans.scrollHeight;
            //     ans.classList.add('line_hide');
            //     const visibleHeight = ans.offsetHeight;
            //      console.log('Full---height:', fullHeight, 'Visible---height:', visibleHeight);
      
            //     if (fullHeight <= visibleHeight) {
            //       readMoreBtn.style.display = 'none';
            //     }
            //   });
              
            // });
                        
    }

    generateDueDateUrl(data) {
      let baseUrl = "details";
    
      // IVF Method
      if (data.ivftransferDate && data.embryoTransfer) {
        const date = this.formatDateToYYYYMMDD(data.ivftransferDate);
        return `${baseUrl}/IVF-Method/${date}/${encodeURIComponent(data.embryoTransfer)}`;
      }
    
      // Ultrasound Method
      else if (data.ultrasoundDate && data.ultrasoundAge) {
        const date = this.formatDateToYYYYMMDD(data.ultrasoundDate);
        const week = data.ultrasoundAge.week;
        const days = data.ultrasoundAge.day || data.ultrasoundAge.days || 0;
        return `${baseUrl}/Ultrasound-Method/${date}/${week}/${days}`;
      }
    
      // Last Period
      else if ((data.lmpDate && data.avgcycledays) || (data.FirstDateOfLMP && data.avgCycleDays)) {
        const lmp = data.FirstDateOfLMP || data.lmpDate;
        const cycle = data.avgCycleDays || data.avgcycledays;
        return `${baseUrl}/Last-Period/${this.formatDateToYYYYMMDD(lmp)}/${cycle}`;
      }
    
      // Conception Method
      else if (data.conceptionDate) {
        const date = this.formatDateToYYYYMMDD(data.conceptionDate);
        return `${baseUrl}/Conception-Method/${date}`;
      }
    
      // Fallback
      return `${baseUrl}`;
    }
    
    formatDateToYYYYMMDD(dateStr) {
      const date = new Date(dateStr);
      const yyyy = date.getFullYear();
      const mm = `${date.getMonth() + 1}`.padStart(2, '0');
      const dd = `${date.getDate()}`.padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    }

    landDueDatePage() {
        document.getElementById("lmp").checked = true;
        document.getElementById("FirstDateOfLMP").disabled = false;
    }

    onKeyPressDate = (event) => {
        event.returnValue = false;
        if (event.preventDefault) event.preventDefault();
    }
    hoverDate(event){
        if(document.getElementById("lmp").checked && !event.target.value){
            if(event.target.id!="conceptionDate"){
                event.target.nextSibling.style.display="none";
                event.target.type = "date";
                event.target.readOnly = false;
            }
        }else if(document.getElementById("conception").checked && !event.target.value){
            if(event.target.id=="conceptionDate"){
                console.log("event=======>",event.target);
                event.target.nextSibling.style.display="none";
                event.target.type = "date";
                event.target.readOnly = false;
            }
        }
    }
    hoverOutDate(event){
        if(document.getElementById("lmp").checked && !event.target.value){
            event.target.nextSibling.style.display="block";
            event.target.type = "text";
            // event.target.readOnly = false;
        }else  if(document.getElementById("conception").checked && !event.target.value){
            event.target.nextSibling.style.display="block";
            event.target.type = "text";
            // event.target.readOnly = false;
        }
    }
    onFocusDate = (event) => {
        console.log("onFocusDate================>", event);
        if (document.getElementById("lmp").checked) {
            document.querySelector(".tap_here").style.display = "none";
        } else {
            document.querySelector(".tap_here2").style.display = "none";
        }
        var val;
        if (event.target.value && event.target.value != '') {
            val = new Date(event.target.value);
            var y = val.getFullYear();
            var m = val.getMonth() + 1;
            var d = val.getDate();
            m = m > 9 ? m : "0" + m;
            d = d > 9 ? d : "0" + d;
            var finalVal = y + '-' + m + '-' + d;
            event.target.value = finalVal;
        }
        event.target.type = "date";
        event.target.readOnly = false;
        if (event.preventDefault) event.preventDefault();
        event.target.focus();
    }
    onBlurDate = (event) => {
        if (!document.querySelector("#FirstDateOfLMP").value && document.getElementById("lmp").checked) {
            document.querySelector(".tap_here").style.display = "block";
        }
        else if (!document.querySelector("#conceptionDate").value) {
            document.querySelector(".tap_here2").style.display = "block";
        }
        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        event.target.type = "text";
        event.target.readOnly = true;
        if (event.target.value && event.target.value != '') {
            let date = new Date(event.target.value);
            let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
            event.target.value = day + "-" + months[date.getMonth()] + "-" + date.getFullYear();
        }
    }
    calculateDueDate() {
        var FirstDateOfLMP = document.querySelector("#FirstDateOfLMP").value;
        var avgCycleDays = document.querySelector("#avgCycleDays").value;
        var conceptionDate = document.querySelector("#conceptionDate").value;
        var isLMP = document.getElementById("lmp").checked;
        var isConception = document.getElementById("conception").checked;
        var varified = !1;
        if (isLMP && !isConception) {
            if (FirstDateOfLMP == "" || avgCycleDays == "") {
                varified = !1;
                if (FirstDateOfLMP == "" && avgCycleDays != "") {
                    document.querySelector(".f_date_err").style.display = "block";
                    document.querySelector("#FirstDateOfLMP").style.borderBottom = "1px solid red"
                        ;
                    document.querySelector(".f_date_err").innerHTML = "Please Select Date";
                } else if (FirstDateOfLMP != "" && avgCycleDays == "") {
                    document.querySelector(".a_cycle_err").style.display = "block";
                    document.querySelector("#avgCycleDays").style.borderBottom = "1px solid red"
                    document.querySelector(".a_cycle_err").innerHTML = "Please Enter Average Length of a cycle";
                } else {
                    document.querySelector(".f_date_err").style.display = "block";
                    document.querySelector("#FirstDateOfLMP").style.borderBottom = "1px solid red"
                    document.querySelector(".f_date_err").innerHTML = "Please Select Date";
                    document.querySelector(".a_cycle_err").style.display = "block";
                    document.querySelector("#avgCycleDays").style.borderBottom = "1px solid red"
                    document.querySelector(".a_cycle_err").innerHTML = "Please Enter Average Length of a cycle";
                }
            } else {
                varified = !0;
                document.querySelector(".f_date_err").style.display = "none";
                document.querySelector("#FirstDateOfLMP").style.borderBottom = "1px solid #c4c4c4";
                document.querySelector(".f_date_err").innerHTML = "";
                document.querySelector(".a_cycle_err").style.display = "none";
                document.querySelector("#avgCycleDays").style.borderBottom = "1px solid #c4c4c4"
                document.querySelector(".a_cycle_err").innerHTML = "";
                document.querySelector(".tap_here").style.display = "block";
                document.querySelector(".tap_here2").style.display = "block";
            }
            conceptionDate = ""
        } else if (!isLMP && isConception) {
            if (conceptionDate == "") {
                varified = !1;
                document.querySelector(".c_date_err").style.display = "block";
                document.querySelector("#conceptionDate").style.borderBottom = "1px solid red";
                document.querySelector(".c_date_err").innerHTML = "Please Select Date";
            } else {
                varified = !0;
                document.querySelector(".c_date_err").style.display = "none";
                document.querySelector("#conceptionDate").style.borderBottom = "1px solid #c4c4c4";
                document.querySelector(".c_date_err").innerHTML = "";
            }
            FirstDateOfLMP = "";
            avgCycleDays = ""
        }

        if (varified && (!global.ftk || !navigator.onLine)) {
            if (!navigator.onLine) {
                service.showAlert("Please check internet connection!!");
            } else {
                service.showAlert("Login / Register to get Due Date Calculations");
                var redirectionUrl = global.loginUrl + '?URL=' + global.hosturl + "tools/pregnancy-due-date-calculator/details";
                // var redirectionUrl = global.loginUrl + '?URL=' + global.currentURL;

                if (FirstDateOfLMP == "") {
                    redirectionUrl = "" + redirectionUrl + "/0"
                } else {
                    redirectionUrl = "" + redirectionUrl + "/" + FirstDateOfLMP
                }
                if (avgCycleDays == "") {
                    redirectionUrl = redirectionUrl + "/0"
                } else {
                    redirectionUrl = redirectionUrl + "/" + avgCycleDays
                }
                if (conceptionDate == "") {
                    redirectionUrl = redirectionUrl + "/0"
                } else {
                    redirectionUrl = redirectionUrl + "/" + conceptionDate
                }
                console.log(redirectionUrl);
                window.location.href = service.getRedirectUrl(redirectionUrl)
                // this.props.history.push(service.getRedirectUrl(redirectionUrl));

            }
        }
        if (varified && global.ftk && navigator.onLine) {
            var redirectionUrl = "/tools/pregnancy-due-date-calculator/details";
            if (FirstDateOfLMP == "") {
                redirectionUrl = "" + redirectionUrl + "/0"
            } else {
                redirectionUrl = "" + redirectionUrl + "/" + FirstDateOfLMP
            }
            if (avgCycleDays == "") {
                redirectionUrl = redirectionUrl + "/0"
            } else {
                redirectionUrl = redirectionUrl + "/" + avgCycleDays
            }
            if (conceptionDate == "") {
                redirectionUrl = redirectionUrl + "/0"
            } else {
                redirectionUrl = redirectionUrl + "/" + conceptionDate
            }
            console.log(redirectionUrl);
            // window.location.href = redirectionUrl;
            this.props.history.push(service.getRedirectUrl(redirectionUrl));
            document.querySelector("#FirstDateOfLMP").value = "";
            document.querySelector("#avgCycleDays").value = "";
            document.querySelector("#conceptionDate").value = "";
            document.querySelector(".tap_here").style.display = "block";
            document.querySelector(".tap_here2").style.display = "block";
        }
    }
    checkForm(id) {
        if (!document.getElementById(id).checked) {
            document.getElementById(id).checked = true;
            if (id == "lmp") {
                document.querySelector("#conceptionDate").value = "";
                document.getElementById("avgCycleDays").disabled = false;
                document.getElementById("FirstDateOfLMP").disabled = false;
                document.querySelector(".tap_here2").style.display = "block";
                document.querySelector(".c_date_err.L10_red").style.display = "none";
                document.querySelector("#conceptionDate").style.borderBottom = "";
                document.getElementById("conceptionDate").disabled = true;
            } else {
                document.querySelector("#FirstDateOfLMP").value = "";
                document.querySelector("#avgCycleDays").value = "";
                document.querySelector(".tap_here").style.display = "block";
                document.querySelector(".f_date_err.L10_red").style.display = "none";
                document.querySelector(".a_cycle_err.L10_red").style.display = "none";

                document.querySelector("#FirstDateOfLMP").style.borderBottom = "";
                document.querySelector("#avgCycleDays").style.borderBottom = "";
                document.getElementById("avgCycleDays").disabled = true;
                document.getElementById("FirstDateOfLMP").disabled = true;
                document.getElementById("conceptionDate").disabled = false;
            }
        }
    }

    /* Due Date Calculator Revamp code start-- */
    // state = {
    //     selectedMethod: 'Last Period',
    //     selectedCycleLength: '',
    //     selectedPregnancyLength: '',
    //     selectedPregnancyLengthDay: '',
    //     selectedTransferMethod: '',
    //     isMethodOpen: false,
    //     isCycleLengthOpen: false,
    //     isPregnancyLengthOpen: false,
    //     isPregnancyLengthDayOpen: false,
    //     isTransferMethodOpen: false,
    //     isDescExpanded: false
    // };
      dateInputRef = React.createRef();
      methodRef = React.createRef();
      cycleRef = React.createRef();
      pregnancyRef = React.createRef();
      pregnancyDayRef = React.createRef();
      transferMethodRef = React.createRef();

      // componentDidMount() {
      //   document.addEventListener('click', this.handleOutsideClick);
      // }
    
      componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
      }
    
      // handleOutsideClick = (event) => {
    
      //   if (
      //     this.methodRef.current && !this.methodRef.current.contains(event.target) &&
      //     this.cycleRef.current && !this.cycleRef.current.contains(event.target) &&
      //     this.pregnancyRef.current && !this.pregnancyRef.current.contains(event.target) &&
      //     this.pregnancyDayRef.current && !this.pregnancyDayRef.current.contains(event.target) &&
      //     this.transferMethodRef.current && !this.transferMethodRef.current.contains(event.target)
      //   ) {
      //     this.setState({
      //       isMethodOpen: false,
      //       isCycleLengthOpen: false,
      //       isPregnancyLengthOpen: false,
      //       isPregnancyLengthDayOpen: false,
      //       isTransferMethodOpen: false,
      //       activeDropdownType: '',
      //     });
      //   }
      // };

        handleOutsideClick = (event) => {
          const methodRef = this.methodRef.current;
          const cycleRef = this.cycleRef.current;
          const pregnancyRef = this.pregnancyRef.current;
          const pregnancyDayRef = this.pregnancyDayRef.current;
          const transferMethodRef = this.transferMethodRef.current;
        
          const isClickOutside =
            (!methodRef || !methodRef.contains(event.target)) &&
            (!cycleRef || !cycleRef.contains(event.target)) &&
            (!pregnancyRef || !pregnancyRef.contains(event.target)) &&
            (!pregnancyDayRef || !pregnancyDayRef.contains(event.target)) &&
            (!transferMethodRef || !transferMethodRef.contains(event.target));
        
          if (isClickOutside) {
            // console.log("Outside click — closing dropdowns");
            this.setState({
              isMethodOpen: false,
              isCycleLengthOpen: false,
              isPregnancyLengthOpen: false,
              isPregnancyLengthDayOpen: false,
              isTransferMethodOpen: false,
              activeDropdownType: '',
            });
          }
        };

    
      // toggleDropdown = (type) => {
      //   this.setState({
      //     isMethodOpen: type === 'method' ? !this.state.isMethodOpen : false,
      //     isCycleLengthOpen: type === 'cycle' ? !this.state.isCycleLengthOpen : false,
      //     isPregnancyLengthOpen: type === 'pregnancy' ? !this.state.isPregnancyLengthOpen : false,
      //     isPregnancyLengthDayOpen: type === 'pregnancyDay' ? !this.state.isPregnancyLengthDayOpen : false,
      //     isTransferMethodOpen: type === 'transferMethod' ? !this.state.isTransferMethodOpen : false,
      //     activeDropdownType: this.state[`is${type.charAt(0).toUpperCase() + type.slice(1)}Open`] ? '' : type,
      //   });
      // };
        toggleDropdown = (type) => {
          const newState = {
            isMethodOpen: false,
            isCycleLengthOpen: false,
            isPregnancyLengthOpen: false,
            isPregnancyLengthDayOpen: false,
            isTransferMethodOpen: false,
          };        
          const typeKey = {
            method: 'isMethodOpen',
            cycle: 'isCycleLengthOpen',
            pregnancy: 'isPregnancyLengthOpen',
            pregnancyDay: 'isPregnancyLengthDayOpen',
            transferMethod: 'isTransferMethodOpen',
          }[type];
        
          const willBeOpen = !this.state[typeKey];
          newState[typeKey] = willBeOpen;
          newState.activeDropdownType = willBeOpen ? type : '';
        
          this.setState(newState);
        };

      selectOption = (type, value) => {
        if (type === 'method') {
          this.setState({ selectedMethod: value, isMethodOpen: false,activeDropdownType: '',noLMPDate : false,
            errMsgLMP : '',
            noIVFDate : false,
            errMsgIVF : '',
            noConceptionDate : false,
            errMsgConception : '',
            noUltrasoundDate : false,
            errMsgUltrasound : '', });
        } else if (type === 'cycle') {
          this.setState({ selectedCycleLength: value, isCycleLengthOpen: false,activeDropdownType: '', });
        } else if (type === 'pregnancy') {
          this.setState({ selectedPregnancyLength: value, isPregnancyLengthOpen: false,activeDropdownType: '', });
        } else if (type === 'pregnancyDay') {
          this.setState({ selectedPregnancyLengthDay: value, isPregnancyLengthDayOpen: false,activeDropdownType: '', });
        } else if (type === 'transferMethod') {
          this.setState({ selectedTransferMethod: value, isTransferMethodOpen: false,activeDropdownType: '', });
        }
      };
   
      readMoreClick(event) {
         const button = event.target;
         const dataId = button.getAttribute('data-id');
         const content = document.getElementById(dataId);
         
         if (button.innerHTML === "Read More") {
             button.innerHTML = "Read Less";
             content.style.height = "auto";
             content.classList.remove('line_hide');
         } else {
             button.innerHTML = "Read More";
             content.classList.add('line_hide');
             // content.style.height = "56px";
         }
      }
      // getYesterdayDate() {
      //   const today = new Date();
      //   today.setDate(today.getDate() - 1);
      //   return today.toISOString().split('T')[0];
      // }
      

      handleDueDateCalculation = () => {
        const {
          selectedMethod,
          selectedCycleLength,
          selectedPregnancyLength,
          selectedPregnancyLengthDay,
          selectedTransferMethod
        } = this.state;
      
        const isNewEntry = 1;
        const url = global.api_ci_url + "api/fetchfromCI/duedate~getduedatedetails_v1";
        let body = { isNewEntry };
      
        let redirectPath = ""; // for building clean path-based URL
      
        if (selectedMethod === "Last Period") {
          const lmpDate = document.getElementById("period-date").value;
          const cycleDays = selectedCycleLength ? parseInt(selectedCycleLength) : 28;
      
          if (!lmpDate) {
          this.setState({ noLMPDate: true , errMsgLMP : "Please select first day of last period" });
          return;
          }
            // return alert("Please select first day of last period");
      
          body = {
            FirstDateOfLMP: lmpDate,
            avgCycleDays: cycleDays,
            isNewEntry
          };
      
          redirectPath = `Last-Period/${lmpDate}/${cycleDays}`;
        }
      
        else if (selectedMethod === "Ultrasound Method") {
          const ultrasoundDate = document.getElementById("ultrasound-date").value;
          const weekStr = selectedPregnancyLength?.split(" ")[0] || "0";
          const dayStr = selectedPregnancyLengthDay?.split(" ")[0] || "0";
      
          if (!ultrasoundDate){
            this.setState({ noUltrasoundDate: true , errMsgUltrasound : "Please select ultrasound date" });
            return;
          } 
      
          body = {
            ultrasoundDate,
            ultrasoundAge: {
              week: parseInt(weekStr),
              days: parseInt(dayStr)
            },
            isNewEntry
          };
      
          redirectPath = `Ultrasound-Method/${ultrasoundDate}/${weekStr}/${dayStr}`;
        }
      
        else if (selectedMethod === "IVF Method") {
          const transferDate = document.getElementById("transfer-date").value;
          if (!transferDate){
            this.setState({ noIVFDate: true , errMsgIVF : "Please select transfer date" });
            return;
          } 


      
          const embryoTransfer = selectedTransferMethod?.replace(" transfer", "") || "";
      
          body = {
            ivftransferDate: transferDate,
            embryoTransfer,
            isNewEntry
          };
      
          redirectPath = `IVF-Method/${transferDate}/${encodeURIComponent(embryoTransfer)}`;
        }
      
        else if (selectedMethod === "Conception Method") {
          const conceptionDate = document.getElementById("conception-date")?.value;
          if (!conceptionDate) {
            this.setState({ noConceptionDate: true , errMsgConception : "Please select conception date"
            });
            return
          }
            
      
          body = {
            conceptionDate,
            isNewEntry,
            FirstDateOfLMP: ""
          };
      
          redirectPath = `Conception-Method/${conceptionDate}`;
        }
      
        // ✅ Store locally if user not logged in
        if (!global.ftk) {
          localStorage.setItem("dueDateData", JSON.stringify(body));
        }
      
        // ✅ Redirect to clean URL
        const redirectUrl = service.getRedirectUrl(`/tools/pregnancy-due-date-calculator/details/${redirectPath}`);
        window.location.href = redirectUrl;
      };

      // convert ISO -> display (dd/mm/yyyy)
  isoToDisplay(iso) {
    if (!iso) return "";
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`;
  }

  handleChange = (e) => {
    const val = e.target.value; // this will be YYYY-MM-DD on supported browsers
    this.setState({ dateISO: val });
    if (this.props.onChange) this.props.onChange(val); // optional callback
  };

  // optional helper to open picker programmatically if browser supports it
  openPicker = () => {
    const input = this.dateRef.current;
    if (!input) return;
    if (typeof input.showPicker === "function") {
      input.showPicker();
    } else {
      input.focus();
    }
  };

  // get max date as YYYY-MM-DD
  getYesterdayDate() {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  }
      
      

    /* Due Date Calculator Revamp code end-- */

    render() {
        const {
          selectedMethod,
          selectedCycleLength,
          selectedPregnancyLength,
          selectedPregnancyLengthDay,
          selectedTransferMethod,
          isMethodOpen,
          isCycleLengthOpen,
          isPregnancyLengthOpen,
          isPregnancyLengthDayOpen,
          isTransferMethodOpen,
          noLMPDate,
          errMsgLMP,
          noIVFDate,  
          errMsgIVF,
          noConceptionDate,
          errMsgConception,
          noUltrasoundDate,
          errMsgUltrasound,
          dateISO
        } = this.state;
        console.log("selectedMethod==================>",selectedMethod);

        const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
        const content = (
          <>
          <div className="lop_wrap lop_week">
            <div className={`form-group white-bg ${this.state.activeDropdownType === 'pregnancy' ? 'drop_open' : ''}`}>
              <label htmlFor="pregnancy-length" className="label-text">Length of pregnancy (In weeks)</label>
              <div className="select-wrap" ref={this.pregnancyRef}>
                <div className="custom-select-wrapper">
                  <div className="custom-select-trigger" onClick={() => this.toggleDropdown('pregnancy')}>
                    {selectedPregnancyLength || '28 Weeks'}
                  </div>
                  {isPregnancyLengthOpen && (
                    <div className="custom-options">
                        {Array.from({ length: 42 }, (_, i) => `${i + 1} Weeks`).map((option, index) => (
                        <div
                          key={index}
                          className={`custom-option ${selectedPregnancyLength === option ? 'selected' : ''}`}
                          onClick={() => this.selectOption('pregnancy', option)}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {isMobile && (
                <div className={isPregnancyLengthOpen ? 'arr_icon open' : 'arr_icon'} onClick={() => this.toggleDropdown('pregnancy')}>
                  <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow"/>
                </div>
                )}
              </div>
            </div>
            {/* {noValueData ? <div className="err_msg">{errMsg}</div> :''} */}
          </div>
          <div className="lop_wrap">
            <div className={`form-group white-bg ${this.state.activeDropdownType === 'pregnancyDay' ? 'drop_open' : ''}`}>
              <label htmlFor="pregnancy-day" className="label-text">Length of pregnancy (In days)</label>
              <div className="select-wrap" ref={this.pregnancyDayRef}>
                <div className="custom-select-wrapper">
                  <div className="custom-select-trigger" onClick={() => this.toggleDropdown('pregnancyDay')}>
                    {selectedPregnancyLengthDay || '5 Days'}
                  </div>
                  {isPregnancyLengthDayOpen && (
                    <div className="custom-options">
                      {['1 Days', '2 Days', '3 Days', '4 Days', '5 Days', '6 Days'].map((option, index) => (
                        <div
                          key={index}
                          className={`custom-option ${selectedPregnancyLengthDay === option ? 'selected' : ''}`}
                          onClick={() => this.selectOption('pregnancyDay', option)}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {isMobile && (
                <div className={isPregnancyLengthDayOpen ? 'arr_icon open' : 'arr_icon'} onClick={() => this.toggleDropdown('pregnancyDay')}>
                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" />
                </div>
                )}
              </div>
            </div>
            {/* {noValueData ? <div className="err_msg">{errMsg}</div> :''} */}
          </div>
          </>
        );

        return (
            <main className="duedate-tool main-container">
                <Helmet
                    title="Pregnancy Due Date Calculator - Estimate and Predict Your Date of Delivery"
                    meta={[
                        { "name": "description", "content": "Calculate your baby's due date with our accurate Pregnancy Due Date Calculator. Plan ahead for your special day with ease and confidence." },
                        { "name": "keywords", "content": "due date calculator, pregnancy due date calculator" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
            {/* {isMobile ? (
                    <div className="due_ms_header">
                        <div className="ms_header_name">
                            <a href="#"><span className="arrow-icon" data-icon-font="s"></span></a>
                            <span className="M17_21">Due Date Calculator</span>
                        </div>
                    </div>
                 ):( */}
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools/")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Due Date Calculator</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Pregnancy Due Date Calculator</h1>
                </div>
            {/* )} */}
                <div className="sub-container left">
                    <div className="data-container left">
                    {/* /* Due Date Calculator Revamp code start-- */ }
                        <div className="due_date_sec_wrap">
                            <div className="due_date_desc">
                               <div className={`desc_text_wrap ${isMobile  ? 'line_hide' : '' }`} id="desctext1">
                                Want to know when your baby is due? Try our user-friendly due date calculator tool to find your due date based on the last menstrual period (LMP) or conception date.
                              </div>                            
                              {isMobile && (
                                <div className="desc_readmore" onClick={this.readMoreClick} data-id="desctext1">
                                  Read More
                                </div>
                              )}
                            </div>

                            <div className="duedate_form_wrap">
                                <div className="form-wrap">


                                    {/* Calculation Method Dropdown - Already Present */}
                                    <div className={`form-group white-bg ${this.state.activeDropdownType === 'method' ? 'drop_open' : ''}`}>
                                      <label htmlFor="method" className="label-text">Calculation Method</label>
                                      <div className="select-wrap" ref={this.methodRef}>
                                        <div className="custom-select-wrapper">
                                          <div className="custom-select-trigger" onClick={() => this.toggleDropdown('method')}>
                                            {selectedMethod || 'Last Period'}
                                          </div>
                                          {isMethodOpen && (
                                            <div className="custom-options">
                                              {['Last Period', 'IVF Method', 'Conception Method', 'Ultrasound Method'].map((option, index) => (
                                                <div
                                                  key={index}
                                                  className={`custom-option ${selectedMethod === option ? 'selected' : ''}`}
                                                  onClick={() => this.selectOption('method', option)}
                                                >
                                                  {option}
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                        </div>
                                        <div className={isMethodOpen ? 'arr_icon open' : 'arr_icon'} onClick={() => this.toggleDropdown('method')}>
                                          <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" />
                                        </div>
                                      </div>
                                    </div>
                                    {/* {noValueData ? <div className="err_msg">{errMsg}</div> :''}     */}


                                    {/* Last Period Method */}
                                    {selectedMethod === 'Last Period' && (
                                      <>
                                      <div className={`form-group white-bg ${this.props.noLMPDate ? "err_border" : ""}`}>
                                      <label htmlFor="period-date" className="label-text">First Day of Last Period</label>

                                      <div className="select-wrap" style={{ position: "relative" }} onClick={this.openPicker}>
                                        {/* fake placeholder shown only when no value */}
                                        {!dateISO && <span className="fake-placeholder">dd/mm/yyyy</span>}
                                        <input
                                          ref={this.dateRef}
                                          id="period-date"
                                          name="period-date"
                                          type="date"
                                          value={dateISO}                     // controlled, MUST be YYYY-MM-DD or ""
                                          onChange={this.handleChange}        // required for controlled input
                                          max={this.getYesterdayDate()}
                                          aria-label="First Day of Last Period"
                                        />
                                        <div className="cal_icon_wrap">
                                          <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_calender.svg" alt="Due Date Calender Icon" title="Due Date Calender Icon" />
                                        </div>
                                      </div>

                                      {/* optionally show user-friendly formatted date next to field */}
                                      {dateISO && <div className="display-date">{this.isoToDisplay(dateISO)}</div>}
                                    </div>
                                        {/* <div className= {`form-group white-bg ${noLMPDate ? 'err_border' : ''}`}>
                                          <label htmlFor="period-date" className="label-text"
                                          >First Day of Last Period</label>
                                          <div className="select-wrap" onClick={() => this.dateInputRef.current.showPicker()}>
                                            {!dateISO && <span className="fake-placeholder">dd/mm/yyyy</span>}                                            
                                            <input type="date" id="period-date" name="period-date" 
                                            // value={this.state.periodDate || ""}
                                            ref={this.dateInputRef} max={this.getYesterdayDate()} // restrict to today or earlier
                                            />
                                            
                                            <div className="cal_icon_wrap">
                                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_calender.svg" alt="calendar icon" />
                                            </div>
                                          </div>
                                        </div> */}
                                        {noLMPDate ? <div className="err_msg">{errMsgLMP}</div> :''}

                                        <div className={`form-group white-bg ${this.state.activeDropdownType === 'cycle' ? 'drop_open' : ''}`}>
                                          <label htmlFor="cycle-length" className="label-text">Average length of cycle</label>
                                          <div className="select-wrap" ref={this.cycleRef}>
                                            <div className="custom-select-wrapper">
                                              <div className="custom-select-trigger" id="avg_length_of_cycle" onClick={() => this.toggleDropdown('cycle')}>
                                                {selectedCycleLength || '28 Days'}
                                              </div>
                                              {isCycleLengthOpen && (
                                                <div className="custom-options">
                                                  {['28 Days', '27 Days', '26 Days', '29 Days', '30 Days'].map((option, index) => (
                                                    <div
                                                      key={index}
                                                      className={`custom-option ${selectedCycleLength === option ? 'selected' : ''}`}
                                                      onClick={() => this.selectOption('cycle', option)}
                                                    >
                                                      {option}
                                                    </div>
                                                  ))}
                                                </div>
                                              )}
                                            </div>
                                            <div className={isCycleLengthOpen ? 'arr_icon open' : 'arr_icon'} onClick={() => this.toggleDropdown('cycle')}>
                                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" />
                                            </div>
                                          </div>
                                        </div>
                                        {/* {noValueData ? <div className="err_msg">{errMsg}</div> :''} */}
                                      </>
                                    )}


                                    
                                    {/* Ultrasound Method */}
                                    {selectedMethod === 'Ultrasound Method' && (
                                      <>
                                        <div className= {`form-group white-bg ${noUltrasoundDate ? 'err_border' : ''}`}>
                                          <label htmlFor="ultrasound-date" className="label-text">Date of Ultrasound</label>
                                          <div className="select-wrap" onClick={() => this.dateInputRef.current.showPicker()}>
                                            <input type="date" id="ultrasound-date" name="ultrasound-date" ref={this.dateInputRef} max={this.getYesterdayDate()} />
                                            <div className="cal_icon_wrap">
                                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_calender.svg" alt="Due Date Calender Icon" title="Due Date Calender Icon" />
                                            </div>
                                          </div>
                                        </div>
                                        {noUltrasoundDate ? <div className="err_msg">{errMsgUltrasound}</div> :''}
                                       <>
                                        {!isMobile ? <div className="two_select_wrap">{content}</div> : content}
                                       </>
                                        
                                      </>
                                    )}
                                    
                                    {/* IVF Method */}
                                    {selectedMethod === 'IVF Method' && (
                                      <>
                                        <div className= {`form-group white-bg ${noIVFDate ? 'err_border' : ''}`}>
                                          <label htmlFor="transfer-date" className="label-text">Date of Transfer</label>
                                          <div className="select-wrap" onClick={() => this.dateInputRef.current.showPicker()}>
                                            <input type="date" id="transfer-date" name="transfer-date" ref={this.dateInputRef}   max={this.getYesterdayDate()} // restrict to today or earlier
                                            />
                                            <div className="cal_icon_wrap">
                                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_calender.svg" alt="Due Date Calender Icon" title="Due Date Calender Icon" />
                                            </div>
                                          </div>
                                        </div>
                                        {noIVFDate ? <div className="err_msg">{errMsgIVF}</div> :''}

                                        <div className={`form-group white-bg ${this.state.activeDropdownType === 'transferMethod' ? 'drop_open' : ''}`}>
                                          <label htmlFor="transfer-method" className="label-text">Transfer Date Method</label>
                                          <div className="select-wrap" ref={this.transferMethodRef}>
                                            <div className="custom-select-wrapper">
                                              <div className="custom-select-trigger" onClick={() => this.toggleDropdown('transferMethod')}>
                                                {selectedTransferMethod || '5 Day transfer'}
                                              </div>
                                              {isTransferMethodOpen && (
                                                <div className="custom-options">
                                                  {['3 Day transfer', '5 Day transfer'].map((option, index) => (
                                                    <div
                                                      key={index}
                                                      className={`custom-option ${selectedTransferMethod === option ? 'selected' : ''}`}
                                                      onClick={() => this.selectOption('transferMethod', option)}
                                                    >
                                                      {option}
                                                    </div>
                                                  ))}
                                                </div>
                                              )}
                                            </div>
                                            <div className={isTransferMethodOpen ? 'arr_icon open' : 'arr_icon'} onClick={() => this.toggleDropdown('transferMethod')}>
                                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" />
                                            </div>
                                          </div>
                                        </div>
                                        {/* {noValueData ? <div className="err_msg">{errMsg}</div> :''} */}
                                      </>
                                    )}
                                    
                                    {/* Conception Method */}
                                    {selectedMethod === 'Conception Method' && (
                                     <>
                                      <div className= {`form-group white-bg ${noConceptionDate ? 'err_border' : ''}`}>
                                        <label htmlFor="conception-date" className="label-text">Date I Conceived</label>
                                        <div className="select-wrap" onClick={() => this.dateInputRef.current.showPicker()}>
                                          <input type="date" id="conception-date" name="conception-date" ref={this.dateInputRef}   max={this.getYesterdayDate()} // restrict to today or earlier
                                          />
                                          <div className="cal_icon_wrap">
                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_calender.svg" alt="Due Date Calender Icon" title="Due Date Calender Icon" />
                                          </div>
                                        </div>
                                      </div>
                                      {noConceptionDate ? <div className="err_msg">{errMsgConception}</div> :''}
                                     </>
                                    )}




<div className="reviewed-by">
  <div
    className="doctor-img"
    onClick={() =>
      window.open(
        "https://parenting.firstcry.com/experts/obstetrician-and-gynaecologist/dr-sabiha-anjum/6userid1d7515fcf8dad71",
        "_blank"
      )
    }
    style={{ cursor: "pointer" }}
  >
    <img
      src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/dr_sabiha.jpeg"
      alt="Dr. Sabiha" title="Dr. Sabiha"
    />
  </div>
  <div
    onClick={() =>
      window.open(
        "https://parenting.firstcry.com/experts/obstetrician-and-gynaecologist/dr-sabiha-anjum/6userid1d7515fcf8dad71",
        "_blank"
      )
    }
    style={{ cursor: "pointer" }}
  >
    <div className="reviewed-label">Medically Reviewed By:</div>
    <div className="doctor-name">
      Dr. Sabiha Anjum<span>(Gynecologist/Obstetrician)</span>
    </div>
  </div>
</div>
                               
                                    <button type="submit" className="submit-btn" onClick={this.handleDueDateCalculation}>CALCULATE</button>                                
                                </div>

                            </div>
                            <div className="due_date_contents_wrap">
                                <div className="content_box_wrap">
                                    <h2 className="content_que_wrap">What Is a Due Date Calculator?</h2>
                                    <div className="content_ans_wrap line_hide" id="content1">A pregnancy due date calculator is a software tool that helps generate the estimated due date of delivery (EDD), i.e. the estimated time when you will give birth. Knowing the due date helps healthcare experts and would-be parents prepare for the delivery process and welcome the baby without any hindrances. Nevertheless, it is important to note that the due date calculator, or a pregnancy estimator, gives the ‘estimated’ due date. That means there is no deadline or fixed date; the due date can change by one to two days.</div>
                                    <div className="desc_readmore" onClick={this.readMoreClick} data-id="content1">Read More</div>
                                </div>
                                <div className="content_box_wrap">
                                    <h2 className="content_que_wrap">How to Calculate a Pregnancy Due Date?</h2>
                                    <div className="content_ans_wrap line_hide" id="content2">A delivery due date calculator estimates the delivery date of a pregnant woman based on the conception date, last menstrual cycle, last ultrasound, and IVF transfer date. Let’s explore them one by one.<br />
                                     1. First Day of Last Period Calculating the due date on the pregnancy calculator using the first day of your last menstrual period (LMP) is the most preferred way of determining the estimated due date. Since most pregnancies last around 38 to 40 weeks from conception, the due date is calculated by counting 280 days or 40 weeks from the first day of your last period. You can add the first day of your last period (LMP) and the average length of the cycle on our Pregnancy Due Date Predictor and get the probable date of delivery.<br />
                                     2. Conception Date If you have been dedicatedly tracking your ovulation cycle and symptoms, you might be able to generate the baby’s due date using your conception date. From the conception date, the tool will add 266 days to let you know how far along you are to meet your baby. The conception date method gives the best possible result when you are sure of your conception date.<br /> 
                                     3. Ultrasound Scan Don’t worry if you have forgotten your last menstrual cycle date, not sure when the ovulation occurred or when the conception happened. You can still get an estimated due date of your pregnancy based on the date of your early ultrasound. Although not proven, ultrasound scan method can sometime give more accurate results than the LMP or conception date method.<br />
                                     4. IVF Transfer Date Calculating the due date using the in vitro fertilisation (IVF) transfer date is also possible. Generally, embryo transfers happen either three days or five days after the egg retrieval and fertilisation. So, if it is a three-day transfer, you can count 263 days from the transfer days to get the due date, and if it is a five-day transfer, you can count 261 days from the transfer date.</div>
                                    <div className="desc_readmore" onClick={this.readMoreClick} data-id="content2">Read More</div>
                                </div>
                                <div className="content_box_wrap">
                                    <h2 className="content_que_wrap">Other Methods of Estimating Due Date</h2>
                                    <div className="content_ans_wrap line_hide" id="content3">There are several other ways of determining an estimated due date at your prenatal checkups.<br/>
                                        1. During prenatal checkups, the healthcare provider checks the fundal height—the distance from your pubic bone to the top of your uterus. This will be beneficial in verifying your due date.<br/>
                                        2. Pregnancy milestones, such as the first time your baby's heartbeat is detected (usually around week 9 or 10) and when you first feel the fetal movement (typically between 18 and 22 weeks), can help pinpoint your due date.<br/>
                                        3. The size of your uterus, observed during the initial internal pregnancy exam, can also assist in determining your estimated due date (EDD).
                                    </div>
                                    <div className="desc_readmore" onClick={this.readMoreClick} data-id="content3">Read More</div>
                                </div>
                                <div className="content_box_wrap">
                                    <h2 className="content_que_wrap">How Soon Can I Take a Pregnancy Test?</h2>
                                    <div className="content_ans_wrap line_hide" id="content4">Missed periods, nausea, vomiting, and tender breasts are some of the earliest signs of pregnancy <a target="_blank" rel="nofollow noopener" href="https://www.betterhealth.vic.gov.au/health/healthyliving/pregnancy-signs-and-symptoms">(1)</a>. If you are sure you have missed your menstruation cycle, you can then take a pregnancy test either at home with a pregnancy kit or by visiting the doctor for a blood test to confirm your pregnancy. <a target="_blank" rel="nofollow noopener" href="https://www.nhs.uk/pregnancy/trying-for-a-baby/doing-a-pregnancy-test/">NHS</a> and the <a target="_blank" rel="nofollow noopener" href="https://americanpregnancy.org/resources/pregnancy-calculator/">American Pregnancy Association</a> suggest waiting out the first day of your missed period before you take a pregnancy test <a target="_blank" rel="nofollow noopener" href="https://www.nhs.uk/pregnancy/trying-for-a-baby/doing-a-pregnancy-test/">(2)</a> <a target="_blank" rel="nofollow noopener" href="https://americanpregnancy.org/resources/pregnancy-calculator/">(3)</a>. You can also use an online pregnancy test calculator to understand when to take the test.
                                     If you remember details about your last period, you can get a possible estimate of your pregnancy due date by using the first day of your last period.
                                    </div>
                                    <div className="desc_readmore" onClick={this.readMoreClick} data-id="content4">Read More</div>
                                </div>
                                <div className="content_box_wrap">
                                    <h2 className="content_que_wrap">What Is Gestational Age?</h2>
                                    <div className="content_ans_wrap line_hide" id="content5">Gestational age, in simple terms, is the time period between conception and childbirth. It is a common term used to describe pregnancy or how far along the pregnancy is <a target="_blank" rel="nofollow noopener" href="https://blogs.iu.edu/kinseyinstitute/2023/05/26/gestational-age-vs-fetal-development-what-is-the-difference/">(4)</a>. Gestational age is calculated from the first day of a woman’s last period (LMP) to the current date and is expressed in days or weeks. A normal and healthy gestation age ranges from 38 to 42 weeks <a target="_blank" rel="nofollow noopener" href="https://medlineplus.gov/ency/article/002367.htm">(5)</a>. You can determine gestational age with the help of a pregnancy month calculator.</div>
                                    <div className="desc_readmore" onClick={this.readMoreClick} data-id="content5">Read More</div>
                                </div>
                                <div className="content_box_wrap">
                                    <h2 className="content_que_wrap">What Is Fetal Age?</h2>
                                    <div 
                                    className={`content_ans_wrap ${typeof window !== 'undefined' && window.innerWidth < 768 ? 'line_hide' : ''}`}
                                     id="content6">Fetal age or conceptional age denotes the length of pregnancy from the time of conception.</div>
                                    {typeof window !== 'undefined' && window.innerWidth < 768 ? (
                                          <div className="desc_readmore" onClick={this.readMoreClick} data-id="content6">Read More</div>
                                        ) : null}
                                    {/* <div className="desc_readmore" onClick={this.readMoreClick} data-id="content6">Read More</div> */}
                                </div>
                                <div className="content_box_wrap">
                                    <h2 className="content_que_wrap">How Accurate Is the Due Date?</h2>
                                    <div className="content_ans_wrap line_hide" id="content7">As mentioned above, pregnancy due dates are fairly accurate. But we must remember they are, at last, an estimate, not a guarantee. Due dates, too, can be influenced by natural delays.</div>
                                     {typeof window !== 'undefined' && window.innerWidth < 768 ? (
                                          <div className="desc_readmore" onClick={this.readMoreClick} data-id="content7">Read More</div>
                                        ) : null}
                                     {/* <div className="desc_readmore" onClick={this.readMoreClick} data-id="content7">Read More</div> */}
                                </div>
                                <div className="content_box_wrap">
                                    <h2 className="content_que_wrap">Can My Due Date Change?</h2>
                                    <div className="content_ans_wrap line_hide" id="content8">Yes, it is possible for your due date to change as your pregnancy progresses. There is no need to worry about the change as there could be several factors in the play. It might be changes in your menstrual cycle, like irregular periods, or that your first ultrasound takes place in the second trimester. There could be a change in the due date if your fundal height is not as expected or if the alpha-fetoprotein (AFP) levels are not in the normal range. If you have any doubt regarding the change in the due date, consult your doctor without any hesitation.</div>
                                    <div className="desc_readmore" onClick={this.readMoreClick} data-id="content8">Read More</div>
                                </div>
                                <div className="content_box_wrap">
                                    <h2 className="content_que_wrap">Can I Plan My Due Date?</h2>
                                    <div className="content_ans_wrap line_hide" id="content9">Yes, it is possible to plan your estimated due date. Many couples plan to give birth on a particular festival, while some try to avoid the chance of giving birth in the months of harsh weather. Whatever, the reason is, it is very well possible to plan your due date by timing your conceiving well.
                                    But it is important to remember that even if you can time your conceiving date perfectly with an ovulation tracker, the likelihood of delivering the baby on the exact date is debatable.</div>
                                    <div className="desc_readmore" onClick={this.readMoreClick} data-id="content9">Read More</div>
                                </div>
                                <div className="content_box_wrap">
                                    <h2 className="content_que_wrap">Will My Baby Be Born on Due Date?</h2>
                                    <div className="content_ans_wrap line_hide" id="content10">The likelihood of delivering on the exact due date is 1 in 20. A pregnancy due date is an ‘estimate’ that helps doctors and pregnant mothers be aware of the delivery so they can prepare in advance. So, there is a range of two weeks before or after of the due date in which women are expected to deliver the baby. </div>
                                    <div className="desc_readmore" onClick={this.readMoreClick} data-id="content10">Read More</div>
                                </div>
                            </div>
                        </div>
                    {/* /* Due Date Calculator Revamp code end-- */}
                    
                        <div className="duedatePic" style={{ display: 'none' }}>
                            <img className="entry-thumb td-animation-stack-type0-2" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/DueDateCalculator-Pic.jpg" alt="Pregnancy Due Date Calculator" title="Pregnancy Due Date Calculator" />
                            <div className="duedateMsg">
                                <span className="R15_21">Due date is most probable date on which you are likely to give birth to your baby</span>
                            </div>
                        </div>
                        <div className="duedate-block" style={{ display: 'none' }}>
                            <div className="duedate-lmp">
                                <label className="duedate-radio-container" onClick={() => { this.checkForm("lmp") }}>
                                    <span className="lmp_method M17_42">LMP Method &nbsp;</span>
                                    {/* <span className="question_icon R15_9e"> [?]</span> */}
                                    <input id="lmp" type="radio" name="duedate-radio" />
                                    <span className="checkmark"></span>
                                </label>
                                <div className="duedate-method-msg R12_75">
                                    <span className="R13_9e">Recommended</span>
                                </div>
                                <div className="duedate-firstdate">
                                    <label htmlFor="FirstDateOfLMP" className="M17_9e">First Day of Last Period*  </label>
                                    <input id="FirstDateOfLMP" className="rm_inp duedate-datepicker R17_42" type="text" name="FirstDateOfLMP" onMouseOver={(e)=>this.hoverDate(e)} onMouseOut={(e)=>this.hoverOutDate(e)} onKeyPress={(e) => this.onKeyPressDate(e)} onFocus={(e) => this.onFocusDate(e)} onBlur={(e) => this.onBlurDate(e)} />
                                    <span className="R15_21 tap_here">Tap here to set</span>
                                    <span className="icon calendar-icon" id="calendar-icon" data-icon-font="w"></span>

                                </div>
                                <div className="f_date_err L10_red"></div>
                                <div className="duedate-cycle">
                                    <select id="avgCycleDays" name="avgCycleDays" className="duedate-dropdown">
                                        <option value="" style={{ display: 'none' }} >Average Length of Cycle*</option>
                                        {this.state.objects && this.state.objects.length > 0 && this.state.objects.map((objects, i) =>
                                            <option key={i} value={objects}>{objects}</option>
                                        )}
                                    </select>
                                    <span className="icon arrow-icon" data-icon-font="f"></span>
                                </div>
                                <div className="a_cycle_err L10_red"></div>
                            </div>
                            <div className="duedate-conception">
                                <label className="duedate-radio-container" onClick={() => { this.checkForm("conception") }}>
                                    <span className="lmp_method M17_42">Conception Date Method</span>
                                    {/* <span className="question_icon R15_9e">&nbsp;[?]</span> */}
                                    <input id="conception" type="radio" name="duedate-radio" />
                                    <span className="checkmark"></span>
                                </label>
                                <div className="R12_75 duedate-method-msg">
                                    <span className="R13_9e">Choose only if you are sure</span>
                                </div>
                                <div className="duedate-firstdate">
                                    <label htmlFor="conceptionDate" className="M17_9e">Date I Conceived *</label>

                                    <input id="conceptionDate" className="rm_inp duedate-datepicker R17_42" type="text" name="conceptionDate" onMouseOver={(e)=>this.hoverDate(e)} onMouseOut={(e)=>this.hoverOutDate(e)}  onKeyPress={(e) => this.onKeyPressDate(e)} onFocus={(e) => this.onFocusDate(e)} onBlur={(e) => this.onBlurDate(e)} disabled />
                                    <span className="R15_21 tap_here2">Tap here to set</span>
                                    <span className="icon calendar-icon" id="calendar-icon2" data-icon-font="w"></span>
                                </div>
                                <div className="c_date_err L10_red"></div>
                            </div>
                            <div id="duedateCalBtn" className="askB_1 calculateDuedate" onClick={() => { this.calculateDueDate() }}>
                                <p title="Calculate  My Due Date" className="clcdue">
                                    <span className="clcdue" >CALCULATE MY DUE DATE</span>
                                </p>
                            </div>
                        </div>

                    <FaqsDisclaimer eleRef={this} />
                    
                    <div className="tools_section_wrap">
                        <h2 className="tools_title">Other Pregnancy Tools and Trackers</h2>
                        <div className="tools_box_wrap">
                            <div className="tool_box">
                                <a href="/tools/fetal-movement-tracker/" className="gtmToolClick">
                                    <div className="img_container_wrap gtmToolClick">
                                        <div className="tool_bg_img gtmToolClick">
                                            <img src="https://cdn.fcglcdn.com/brainbees/apps/image/fetus_movement_tracker.jpg" className="gtmToolClick" />
                                        </div>
                                        <img className="tool_icon gtmToolClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_baby_kick.svg" />   
                                    </div>  
                                    <div className="tool_name_wrap gtmToolClick"><span className="gtmToolClick">Baby Kick Counter</span></div>                           
                                </a>
                            </div>
                            <div className="tool_box">
                                <a href="/baby-names/" className="gtmToolClick">
                                    <div className="img_container_wrap gtmToolClick">
                                        <div className="tool_bg_img gtmToolClick">
                                            <img src="https://cdn.fcglcdn.com/brainbees/apps/image/baby_names.jpg" className="gtmToolClick" />
                                        </div>
                                        <img className="tool_icon gtmToolClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_baby_names.svg" alt="Baby Names" title="Baby Names" />   
                                    </div>  
                                    <div className="tool_name_wrap gtmToolClick"><span className="gtmToolClick">Baby Names</span></div>                           
                                </a>
                            </div>
                            <div className="tool_box">
                                <a href="/tools/pregnancy-diet-plan/" className="gtmToolClick">
                                    <div className="img_container_wrap gtmToolClick">
                                        <div className="tool_bg_img gtmToolClick">
                                            <img src="https://cdn.fcglcdn.com/brainbees/apps/image/moms_diet_plan.jpg" className="gtmToolClick" />
                                        </div>
                                        <img className="tool_icon gtmToolClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_diet_plan.svg" />   
                                    </div>  
                                    <div className="tool_name_wrap gtmToolClick"><span className="gtmToolClick">Diet Plan (Expecting Moms)</span></div>                           
                                </a>
                            </div>
                            <div className="tool_box">
                                <a href="/tools/pregnancy-week-by-week-tracker/" className="gtmToolClick">
                                    <div className="img_container_wrap gtmToolClick">
                                        <div className="tool_bg_img gtmToolClick">
                                            <img src="https://cdn.fcglcdn.com/brainbees/apps/image/app_tools_week_byweek_fetal_background.jpg" className="gtmToolClick" />
                                        </div>
                                        <img className="tool_icon gtmToolClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_weekbyweek_fetal.svg" />   
                                    </div>  
                                    <div className="tool_name_wrap gtmToolClick"><span className="gtmToolClick">Week By Week Fetal Developments</span></div>                           
                                </a>
                            </div>
                            <div className="tool_box">
                                <a href="/tools/baby-size-comparison/" className="gtmToolClick">
                                    <div className="img_container_wrap gtmToolClick">
                                        <div className="tool_bg_img gtmToolClick">
                                            <img src="https://cdn.fcglcdn.com/brainbees/apps/image/app_tools_baby_sizecomp_background.jpg" className="gtmToolClick" />
                                        </div>
                                        <img className="tool_icon gtmToolClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_baby_size.svg" />   
                                    </div>  
                                    <div className="tool_name_wrap gtmToolClick"><span className="gtmToolClick">Baby Size Comparison Tool</span></div>                           
                                </a>
                            </div>
                            <div className="tool_box">
                                <a href="/tools/fetal-development-video/" className="gtmToolClick">
                                    <div className="img_container_wrap gtmToolClick">
                                        <div className="tool_bg_img gtmToolClick">
                                            <img src="https://cdn.fcglcdn.com/brainbees/apps/image/app_tool_fetal_development_video_background.jpg" className="gtmToolClick"  />
                                        </div>
                                        <img className="tool_icon gtmToolClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_fetal_dev.svg" />   
                                    </div>  
                                    <div className="tool_name_wrap gtmToolClick"><span className="gtmToolClick">Fetal Development Video</span></div>                           
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* <div className="related_articles_sec">
                        <div className="articles_sec_title">Related Articles</div>
                        <div class="readBlock">
                            <a class="releted-article-section" href="#">            
                                <div class="postImg">
                                    <img src="https://cdn.cdnparenting.com/articles/2024/02/08161259/Article-Feature-image_Keep-your-babys-dry-skin-away.avif" />
                                </div>                    
                                <div class="postDesc">
                                  Popular Chinese Baby Names for Boys and Girls With Meanings            
                                </div>
                                <div class="linkArrow"><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" /></div>
                            </a>          
                        </div>
                        <div class="readBlock">
                            <a class="releted-article-section" href="#">            
                                <div class="postImg">
                                    <img src="https://cdn.cdnparenting.com/articles/2024/02/08161259/Article-Feature-image_Keep-your-babys-dry-skin-away.avif" />
                                </div>                    
                                <div class="postDesc">
                                  Popular Chinese Baby Names for Boys and Girls With Meanings            
                                </div>
                                <div class="linkArrow"><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" /></div>
                            </a>          
                        </div>
                        <div class="readBlock">
                            <a class="releted-article-section" href="#">            
                                <div class="postImg">
                                    <img src="https://cdn.cdnparenting.com/articles/2024/02/08161259/Article-Feature-image_Keep-your-babys-dry-skin-away.avif" />
                                </div>                    
                                <div class="postDesc">
                                  Popular Chinese Baby Names for Boys and Girls With Meanings            
                                </div>
                                <div class="linkArrow"><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" /></div>
                            </a>          
                        </div>
                    </div>
                     */}

                  {Array.isArray(relatedArticles) && relatedArticles.length > 0 ? (
                    <div className="related_articles_sec">
                      <h2 className="articles_sec_title">Related Articles</h2>
                  
                      {relatedArticles.map((article, index) => (
                        <div className="readBlock" key={index}>
                          <a
                            className="releted-article-section"
                            data-gtm-id={article.id}
                            data-gtm-title={article.title}
                            href={article.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div className="postImg">
                              <img src={article.image} alt={article.title} className="articleClick" />
                            </div>
                            <div className="postDesc articleClick">{article.title}</div>
                            <div className="linkArrow">
                              <img
                                src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg"
                                alt="Due Date Down Arrow" title="Due Date Down Arrow"
                                className="articleClick"
                              />
                            </div>
                          </a>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p>No related articles available.</p>
                  )}

                    <DisclaimerReferences eleRef={this} />
                    <div className=""></div>
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
                <script type="application/ld+json" dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                      "@context": "https://schema.org",
                      "@type": "MedicalWebPage",
                      "mainEntity": {
                        "@type": "MedicalEntity",
                        "name": "Pregnancy Due Date Calculator",
                        "description": "Calculate your baby's due date with our accurate Pregnancy Due Date Calculator. Plan ahead for your special day with ease and confidence."
                      },
                      "about": {
                        "@type": "MedicalCondition",
                        "name": "Pregnancy"
                      },
                      "name": "Pregnancy Due Date Calculator",
                      "url": "https://parenting.firstcry.com/tools/pregnancy-due-date-calculator/",
                      "reviewedBy": {
                        "@type": "Person",
                        "name": "Dr. Sabiha Anjum",
                        "jobTitle": "MBBS, DGO (Obstetrics & Gynaecology)",
                        "affiliation": {
                          "@type": "Organization",
                          "name": "FirstCry Parenting"
                        },
                        "url": "https://parenting.firstcry.com/experts/obstetrician-and-gynaecologist/dr-sabiha-anjum/6userid1d7515fcf8dad71"
                      }
                    })
                }}></script>
            </main>
        )
    }
}

// export default DueDate;
export default withLocation(DueDate);
